<template lang="pug">
  .widget
    .widget__img
      img(src='@/assets/img/widget-design_all.jpg' alt='widget-design-all' v-if="!tickets && !date")
      img(src='@/assets/img/widget-design.jpg' alt='widget-design' v-if="(tickets && date)")
      img(src='@/assets/img/widget-design_date.jpg' alt='widget-design-date' v-if="tickets && !date")
      img(src='@/assets/img/widget-design_tickets.jpg' alt='widget-design-tickets' v-if="!tickets && date")
</template>

<script>
export default {
    props: ['tickets', 'date'],
}
</script>

<style lang="scss">
.widget{
    &__img{
      img{
        display: block;
        max-width: 100%;
      }
    }
}
</style>
